var _props$computed$metho;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default (_props$computed$metho = {
    props: ['property'],
    computed: {
        occupancy_percentage: function occupancy_percentage() {
            return Math.round(this.property.occupancy_percentage * 100 * 100) / 100;
        }
    },
    methods: {
        viewVacantUnits: function viewVacantUnits() {
            var units = this.property.units.filter(function (unit) {
                return unit.status == 'Vacant - Not Leased' || unit.status == 'NTV - Available';
            });
            this.openUnitsModal({ units: units, title: 'Available Units' });
        },
        openUnitsModal: function openUnitsModal(units) {
            this.$refs.propertyUnits.openFullModal(units);
        },
        openRentRoll: function openRentRoll() {
            Event.$emit('manually-select-tab', { name: 'Reports' });
            Event.$emit('global-defaults-reporting', {
                reportComponent: "new-rent-roll",
                reportId: "NEW_RENT_ROLL",
                reportTable: "units",
                reportType: "Rent Roll Report"
            });
        }
    }
}, _defineProperty(_props$computed$metho, 'computed', {
    pieChartData: function pieChartData() {
        return [['VACANT: ' + this.property.kpis.vacancy_count, this.property.kpis.vacancy_count], ['LEASED: ' + this.property.kpis.leased_count, this.property.kpis.leased_count], ['MONTH TO MONTH: ' + this.property.kpis.month_to_month_count, this.property.kpis.month_to_month_count]];
    }
}), _defineProperty(_props$computed$metho, 'data', function data() {
    return {
        loading: true,
        investment: {
            'name': "Lincoln Meadows",
            'purchase_date': '05/01/2015',
            'purchase_price': 6416276,
            'remodel_cost': 870000,
            'investor_count': 12,
            'unit_count': 265,
            'price_per_unit': 47563,
            'interest_rate_interim': 4.75,
            'interest_rate_fannie': 4.00
        }
    };
}), _props$computed$metho);


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/property/PropertySummary.vue
// module id = hIjP
// module chunks = 0 1